import { TableHeaderType } from '@fullscreendigital/carrefour-dex-fe/dist/cjs/components/Table'

export const columns: Array<TableHeaderType> = [
  {
    title: 'Numar aviz',
    field: 'noticeNumber',
    align: 'left'
  },
  {
    title: 'Magazin',
    field: 'shopName',
    align: 'left'
  },
  {
    title: 'Numar stive',
    field: 'stackNumber',
    align: 'left'
  },
]
